import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import { MultiAppAuthenticationViewMode } from '../constants';
import AuthUtils from '../../../utils/authentication';
import { MultiAppAuthenticationForm } from '../../../components/MultiAppAuthentication/Form';

interface MultiAppAuthenticationFormOwnProps {
	viewMode: MultiAppAuthenticationViewMode;
}

const mapStateToProps = (state: StoreState, ownProps: MultiAppAuthenticationFormOwnProps) => {
	const { multiAppAuthenticationInfos, appInfos, galleryInfos: { config } } = state;
	const { form, aspConnexionStatus, credentials } = multiAppAuthenticationInfos;
	// userLocale is sent as a prop, to allow the rerendering of placeholders when the language is switched
	const { userLocale } = appInfos;

	const isLoginView = AuthUtils.isLoginView(ownProps.viewMode);
	const isPasswordView = AuthUtils.isPasswordView(ownProps.viewMode);
	const isCompanyView = AuthUtils.isCompanyView(ownProps.viewMode);
	const isCreationView = AuthUtils.isCreationView(ownProps.viewMode);

	const login = credentials && credentials.login ? credentials.login : form.login;
	const password = credentials && credentials.password ? credentials.password : form.password;
	return {
		form: { ...form, login, password },
		aspConnexionStatus,
		userLocale,
		isLoginView,
		isPasswordView,
		isCompanyView,
		isCreationView,
		galleryConfig: config
	};
};

export default connect(mapStateToProps)(MultiAppAuthenticationForm);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/Form/index.tsx